// First time creating a serviceCart cookie which means this is the first time the customer has added a product.
function firstTimeMode(details) {
	const { productHandle, productTitle, featuredImage, variantList, weight, productId } = details;
	const editID = uuidv4();

	let firstTimeCookie = {};

	firstTimeCookie[editID] = {
		productHandle,
		productTitle,
		featuredImage,
		variantList,
		weight,
		productId,
		quantity: 1,
		lineItemPrice: 0
	};

	Cookies.set("serviceCart", JSON.stringify(firstTimeCookie), {
		sameSite: "none",
		secure: true,
	});

	return (window.location.href =  "/pages/repair-service-cart");
}

// The customer has selected the "Edit Issues" button from the cart page and is now editing the issues for a specific product with a specific editID.
function editMode(details) {
	const { editID, variantList } = details;
	const currentCookie = JSON.parse(Cookies.get("serviceCart"));

	// Replace the existing variantList for the specific editID with the new issues selected.
	currentCookie[editID].variantList = variantList;

	Cookies.set("serviceCart", JSON.stringify(currentCookie), {
		sameSite: "none",
		secure: true,
	});

	return (window.location.href =  "/pages/repair-service-cart");
}

// The customer is adding another product to the repair cart.
function addingProductMode(details) {
	const { productHandle, productTitle, featuredImage, variantList, weight, productId } = details;
	const editID = uuidv4();
	const currentCookie = JSON.parse(Cookies.get("serviceCart"));

	currentCookie[editID] = {
		productHandle,
		productTitle,
		featuredImage,
		variantList,
		weight,
		productId,
		quantity: 1,
		lineItemPrice: 0
	};

	Cookies.set("serviceCart", JSON.stringify(currentCookie), {
		sameSite: "none",
		secure: true,
	});

	return (window.location.href =  "/pages/repair-service-cart");
}

// Return a collection of selected issues (nodes)
function getCheckedInputs() {
	return new Promise((resolve, reject) => {
		const variantList = [];
		const selectedIssues = document.querySelectorAll(
			'input[name="issues"]:checked'
		);

		if (selectedIssues.length === 0) {
			reject(new Error("No issue has been selected."));
		} else {
			for (let i = 0; i < selectedIssues.length; i++) {
				const { id } = selectedIssues[i];
				variantList.push(id);
			}
			resolve(variantList);
		}
	});
}

function removeIssue(editID, variant, qty) {
	const serviceCart = JSON.parse(Cookies.get("serviceCart"));
	delete serviceCart[editID].variantList[variant];
	if (isEmpty(serviceCart[editID].variantList)) {
		return removeDevice(editID);
	} else {
		serviceCart[editID].quantity = parseFloat(qty);
		serviceCart[editID].lineItemPrice = 0;
		Cookies.set("serviceCart", JSON.stringify(serviceCart), {
			sameSite: "none",
			secure: true,
		});
		return location.reload();
	}
}

function removeDevice(editID) {
	const serviceCart = JSON.parse(Cookies.get("serviceCart"));
	delete serviceCart[editID];
	Cookies.set("serviceCart", JSON.stringify(serviceCart), {
		sameSite: "none",
		secure: true,
	});
	return location.reload();
}


/* 
  When removing an issue, we will check if all the issues have been removed. 
  By passing in the specific product's variantList, we convert the list of objects
  to an array and if the length is 0, we know all the issues have been removed.
*/
const isEmpty = objectVariantList => Object.keys(objectVariantList).length == 0 ? true : false;


/*
	By default elements with class 'hide-if-empty-cart' will be hidden,
	in case we have something in cart we are going to display them.
*/

function changeVisibility(){
	const elementsToShow = document.querySelectorAll('.hide-if-empty-cart');
	if(!elementsToShow) return;

	const serviceCartCookie = Cookies.get('serviceCart');
	if(!serviceCartCookie || Object.keys(JSON.parse(serviceCartCookie)).length == 0) return; // there are no items in cart, we leave elements hidden

	elementsToShow.forEach((element) => {
		element.hidden = false;
	});
}

document.addEventListener('DOMContentLoaded', changeVisibility);